import React from 'react';
import './styles.css';

const Spinner = () => {
  return (
    <div className="spinner-container">
      <div className="lds-dual-ring"></div>
    </div>
  );
};

export default Spinner;
